﻿export class OrganizerNote {
    public NoteText: string;
    public NoteDID: string;
    public NoteTitle: string;
    public ObjectDID: string;
    public ObjectType: string;
}